import { PendingRegistration } from '../../../dto/pending-registration';

export class RegistrationSelection {
  selected = new Array<PendingRegistration>();

  isSelected(item: PendingRegistration) {
    return this.selected.some((i) => i.id === item.id);
  }

  get count() {
    return this.selected.length;
  }

  hasValue() {
    return this.selected.length > 0;
  }

  clear() {
    this.selected = [];
  }

  select(item: PendingRegistration) {
    const localItem = this.selected.find((i) => i.id === item.id);
    if (!localItem) {
      this.selected.push(item);
    }
  }

  toggle(item: PendingRegistration) {
    const localItem = this.selected.find((i) => i.id === item.id);
    if (localItem) {
      this.selected = this.selected.filter((i) => i !== localItem);
    } else {
      this.selected.push(item);
    }
  }
}
